export const DOUBLE_CLICK_DELAY = 250;
export const HIDE_OVERLAY_DELAY = 100;
export const SHOW_OVERLAY_DELAY = 200;
export const HOVER_SPEED_SENSITIVITY = 0.1;
export const MOUSE_SPEED_MEASURE_INTERVAL = 100;
